import { colorTokens } from '../tokens/colors.ts'

const { other, primary } = colorTokens.global
const { epcRating } = colorTokens.semantic

export const DEFAULT_COLORS = [
  primary[500],
  other.teal[500],
  other.blue[500],
  other.yellow[500],
  other.coral[500],
  other.cyan[500],
  other.pink[500],
  other.green[500],
  other.orange[500],
  other.red[500]
] as const

export const DEFAULT_PATTERN_FOREGROUND = 'rgba(255, 255, 255, 0.55)'

/**
 * Pre-built category color arrays derived from {@link colorTokens}.
 * Pass these to the `categoryColors` prop for common use-cases.
 */
export const CHART_CATEGORY_COLORS = {
  epc: [
    epcRating.A.surface,
    epcRating.B.surface,
    epcRating.C.surface,
    epcRating.D.surface,
    epcRating.E.surface,
    epcRating.F.surface,
    epcRating.G.surface
  ],
  other: [
    other.blue[500],
    other.teal[500],
    other.green[500],
    other.yellow[500],
    other.orange[500],
    other.coral[500],
    other.red[500],
    other.pink[500],
    other.purple[500],
    other.deepPurple[500],
    other.navy[500],
    other.cyan[500]
  ],
  components: {
    wall: [
      other.blue[200],
      other.blue[300],
      other.blue[400],
      other.blue[500],
      other.blue[600],
      other.blue[700],
      other.blue[800],
      other.blue[900]
    ],
    roof: [
      other.teal[200],
      other.teal[300],
      other.teal[400],
      other.teal[500],
      other.teal[600],
      other.teal[700],
      other.teal[800],
      other.teal[900]
    ],
    window: [
      other.green[200],
      other.green[300],
      other.green[400],
      other.green[500],
      other.green[600],
      other.green[700],
      other.green[800],
      other.green[900]
    ],
    door: [
      other.yellow[200],
      other.yellow[300],
      other.yellow[400],
      other.yellow[500],
      other.yellow[600],
      other.yellow[700],
      other.yellow[800],
      other.yellow[900]
    ],
    chimney: [
      other.orange[200],
      other.orange[300],
      other.orange[400],
      other.orange[500],
      other.orange[600],
      other.orange[700],
      other.orange[800],
      other.orange[900]
    ],
    ground: [
      other.deepPurple[200],
      other.deepPurple[300],
      other.deepPurple[400],
      other.deepPurple[500],
      other.deepPurple[600],
      other.deepPurple[700],
      other.deepPurple[800],
      other.deepPurple[900]
    ]
  }
} as const
